import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Crown } from 'lucide-react';
import { Container } from '../components/platform/ui';
import AdminUsers from './AdminUsers';
import AdminPayments from './admin/AdminPayments';
import AdminProducts from './admin/AdminProducts';
import AdminNews from './admin/AdminNews';
import AdminCourses from './admin/AdminCourses';
import AdminRequests from './admin/AdminRequests';
import { useAuth } from '../contexts/AuthContext';

// [ключ, компонент, право]; право null — только администратор. Название — pl.admin.tabs.<ключ>
const TABS = [
  ['users', AdminUsers, null],
  ['payments', AdminPayments, 'payments'],
  ['products', AdminProducts, 'catalog'],
  ['news', AdminNews, 'news'],
  ['courses', AdminCourses, 'courses'],
  ['requests', AdminRequests, 'requests'],
];

// Доступ к странице и ко всем её запросам проверяется на сервере (роль admin); AdminRoute лишь скрывает интерфейс.
const AdminPage = () => {
  const { user } = useAuth();
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'ru').slice(0, 2) === 'en' ? 'en' : 'ru';
  const [tab, setTab] = useState(() => {
    try { return localStorage.getItem('admin_tab') || 'users'; } catch (e) { return 'users'; }
  });
  const select = (k) => { setTab(k); try { localStorage.setItem('admin_tab', k); } catch (e) { /* ignore */ } };
  const allowed = TABS.filter(([, , perm]) => user?.is_admin || (perm && (user?.permissions || []).includes(perm)));
  const current = allowed.find((x) => x[0] === tab) || allowed[0] || TABS[0];
  const [activeKey, Current] = current;
  return (
    <div className="min-h-screen paper-texture" data-testid="admin-page">
      <header className="border-b-2 border-black bg-[#F5F1E8] tech-lines">
        <Container className="py-4 flex flex-wrap items-center justify-between gap-3">
          <Link to="/cabinet" className="inline-flex items-center gap-2 hover:text-[#C41E3A]"><ArrowLeft size={20} />{t('pl.admin.page.back')}</Link>
          <div className="flex items-center gap-2"><Crown size={22} className="text-[#C41E3A]" /><h1 className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>{t('pl.admin.page.title')}</h1></div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">{user?.email}</span>
            <div className="flex" role="group" aria-label={t('pl.admin.page.language')}>
              {['ru', 'en'].map((l) => (
                <button key={l} type="button" onClick={() => i18n.changeLanguage(l)} aria-pressed={lang === l}
                  className={`px-2 py-1 border-2 border-black text-sm uppercase ${lang === l ? 'bg-black text-white' : 'bg-white hover:bg-gray-100'}`}>{l}</button>
              ))}
            </div>
          </div>
        </Container>
      </header>
      <Container className="py-8">
        <nav className="flex gap-2 flex-wrap mb-8" aria-label={t('pl.admin.page.nav')}>
          {allowed.map(([k]) => (
            <button key={k} onClick={() => select(k)} className={`px-4 py-2 border-2 border-black ${activeKey === k ? 'bg-black text-white' : 'bg-[#F5F1E8] hover:bg-white'}`}>{t(`pl.admin.tabs.${k}`)}</button>
          ))}
        </nav>
        <Current />
      </Container>
    </div>
  );
};

export default AdminPage;
